import React from "react";
import { navigate } from "gatsby";

import { Link } from "../../../utils/customLink";
import { getCDNProviderToUse } from "../../../utils/base";

import Image from "../../image";

import ArrowRightIcon from "../../../images/icons/arrow-right-icon.inline.svg";

const BlogCard = ({
  blog,
  titleClass = "text-xl font-semibold",
  showMiniImg = true,
  enableLink = false
}) => {
  return (
    <div
      className={`blog-swipe-card relative max-w-sm bg-transparent md:h-[210px] h-[320px] border-l-2 border-black-lighter dark:border-white opacity-50 ${
        enableLink ? "cursor-pointer" : ""
      }`}
      onClick={() => (enableLink ? navigate(blog?.slug) : null)}
    >
      <div className="px-4 pb-4 text-section-title-text">
        <div
          className={titleClass}
          dangerouslySetInnerHTML={{ __html: blog.title }}
        />
        <div
          className="text-xs"
          dangerouslySetInnerHTML={{
            __html:
              blog.caption.length > 50
                ? blog.caption.slice(0, 50).concat("...")
                : blog.caption
          }}
        />

        {blog?.caption && (
          <div
            className="text-xs"
            dangerouslySetInnerHTML={{
              __html:
                blog?.caption.length > 50
                  ? blog?.caption.slice(0, 50).concat("...")
                  : blog?.caption
            }}
          />
        )}

        {enableLink && (
          <Link
            className="flex items-center justify-start w-full h-10 gap-2 text-base font-semibold leading-7 tracking-wider underline bg-transparent md:hidden md:w-max text-black-lighter dark:text-sm dark:text-white"
            to={blog?.slug ?? "#"}
          >
            <span>Read the article</span>
            <ArrowRightIcon className="stroke-black-lighter dark:stroke-white" />
          </Link>
        )}
      </div>
      <div className="flex items-center justify-center w-[90%] h-[45vw] md:h-[74px] absolute left-0 md:right-3 md:bottom-0 bottom-5 dark:bg-transparent ">
        <Image
          imageAlt={blog?.title}
          image={blog?.thumbImg?.gatsbyImage}
          imageClass="object-cover object-center w-full h-full rounded-tr-3xl grayscale group-hover:grayscale-0"
          sourceUrl={getCDNProviderToUse({
            width: 300,
            uri: blog?.thumbImg?.sourceUrl
          })}
        />
        {blog?.category?.name && (
          <div className="absolute right-0 bottom-0 px-2 flex justify-center items-center min:w-[74px] w-auto h-4 bg-white dark:bg-gray-standard border-r-[3px] border-green-standard">
            <span className="text-xs underline text-black-lighter dark:text-gray-generic">
              {blog?.category?.name}
            </span>
          </div>
        )}
      </div>

      {showMiniImg && (
        <div className="flex items-center justify-center md:hidden h-[98px] w-[98px] absolute left-0 bottom-0 dark:bg-transparent ">
          <Image
            imageAlt={blog?.title}
            image={blog?.thumbImg?.gatsbyImage}
            imageClass="object-cover object-center h-full rounded-tr-3xl grayscale group-hover:grayscale-0"
            sourceUrl={getCDNProviderToUse({
              width: 300,
              uri: blog?.thumbImg?.sourceUrl
            })}
          />
        </div>
      )}
    </div>
  );
};

export default BlogCard;
